import React, { useEffect, useState } from 'react';
import TopicoTexto from '../Componentes/TopicoTexto';
import ModalConfirmacao from '../Componentes/ModalConfirmacao';
import { useRef } from 'react';
import { apiService } from '../Services/ApiService';
import CabecalhoDashboard from '../Componentes/CabecalhoDashboard';
import CardDashboardView from './../Componentes/CardDashboardView';

export default function GeneralDashboard() {
  const componentRef = useRef();
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });
  const { get } = apiService();
  const [dashboard, setDashboard] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getDashboard();
  }, []);

  const getDashboard = async () => {
    setIsLoading(true);

    try {
      const endpoint = `dashboard/environment/readings/card`;
      const response = await get(endpoint);

      if (response) {
        setDashboard(response);
      } else {
        setModalError({ visible: true, message: 'Resposta inválida da API' });
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setModalError({ visible: true, message: 'Erro ao buscar dados do ambiente' });
    } finally {
      setIsLoading(false);
    }
  };

  function defineStatus(tempMinimo, tempMaximo, atual) {
    if (atual < tempMinimo || atual > tempMaximo) {
      return 'NG';
    } else if (atual > tempMinimo + 1 && atual < tempMaximo - 1) {
      return 'OK';
    } else {
      return 'WARN';
    }
  }
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  return (
    <>
      <CabecalhoDashboard />
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}
      <div className="ContainerGeral" ref={componentRef} style={{ marginLeft: '5%' }}>
        <TopicoTexto titulo="Dashboard: Resumo de Ambientes" largura={'80%'} />
        <div style={{ display: 'flex', flexDirection: 'row', width: '80vw' }}>
          <div className="CardsGeladeiraView">
            {dashboard.map((item) => (
              <CardDashboardView
                key={item.id}
                height={230}
                maxW={280}
                top={-20}
                width={'100%'}
                temperature={item.temperature}
                humidity={item.humidity}
                data={formatDate(item.timestamp)}
                ok={defineStatus(
                  item.minTemperature,
                  item.maxTemperature,
                  item.temperature ? item.temperature : 0,
                )}
                nome={item.name}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
